module.exports = "#app{\n    min-width: 1200px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main